/** The three.js lights that stand for the environment's ambient, not for a Light3D of the scene. */
/**
 * @canonical Whether a light stands for the environment's ambient
 */
export function isAmbientLight(object) {
    const o = object;
    return !!(o.isAmbientLight || o.isHemisphereLight || o.isLightProbe);
}
//# sourceMappingURL=ambientLight.js.map